/*
 * Karigur — global external-link hardening.
 * Forces every EXTERNAL link (host different from the store / brand) to open in
 * a new tab with rel="noopener noreferrer". Covers theme markup AND merchant
 * rich-text / RTE links that Liquid cannot reach. Idempotent, and re-runs on
 * theme-editor section loads, bfcache restores, and dynamically inserted DOM
 * (cart drawer, predictive search, etc.). Leaves internal links, relative
 * links, in-page #anchors, mailto:/tel:/sms:/javascript: alone, and never
 * new-tabs the Shopify checkout/account or other first-party hosts.
 */
(function () {
  'use strict';

  // Treated as internal even when written as an absolute URL.
  var INTERNAL = ['karigur.com', 'myshopify.com', 'shopify.com', 'shop.app'];

  function internalHost(host) {
    if (!host) return true;
    if (host === location.hostname) return true;
    for (var i = 0; i < INTERNAL.length; i++) {
      if (host === INTERNAL[i] || host.slice(-(INTERNAL[i].length + 1)) === '.' + INTERNAL[i]) return true;
    }
    return false;
  }

  function hardenEl(a) {
    if (!a || !a.getAttribute || a.dataset.kbExt === '1') return;
    var href = a.getAttribute('href');
    if (!href || /^(#|mailto:|tel:|sms:|javascript:|data:)/i.test(href)) return;
    var host;
    try { host = new URL(a.href, location.href).hostname; } catch (e) { return; }
    if (internalHost(host)) return;
    a.setAttribute('target', '_blank');
    var rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
    if (rel.indexOf('noopener') < 0) rel.push('noopener');
    if (rel.indexOf('noreferrer') < 0) rel.push('noreferrer');
    a.setAttribute('rel', rel.join(' '));
    a.dataset.kbExt = '1';
  }

  function harden(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.tagName === 'A') hardenEl(root);
    var links = root.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) hardenEl(links[i]);
  }

  function run() { harden(document.body); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  document.addEventListener('shopify:section:load', function (e) { harden(e.target); });
  window.addEventListener('pageshow', run);

  if (window.MutationObserver) {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) harden(added[j]);
        }
      }
    });
    var start = function () { try { mo.observe(document.body, { childList: true, subtree: true }); } catch (e) {} };
    if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
  }
})();
